<template>
  <div class="variation">
    <CircleSelect v-if="product && product.variation && product.variation.length > 1" :configurationGroup="configurationGroup" :type-single-row="true" :preview="true" @input="onCheckChange($event)" />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import CircleSelect from './CircleSelect.vue';

export default {
  name: 'Variation',
  components: {
    CircleSelect,
  },
  data() {
    return {
      hoveredVariation: null,
      resetHoveredVariationTimeout: null,
    };
  },
  computed: {
    ...mapState('product', [
      'product'
    ]),

    configurationGroup() {
      if(this.product && this.product.variation) {
        return {
          attributeId: -1,
          name: 'Color',
          configuration: this.product.variation.map((variation, index) => ({
            hashKey: variation.hashKey,
            valueId: index,
            value: variation.fabricAndStain,
            imageUrl: variation.variationImageUrl,
            selected: this.product.hashKey === variation.hashKey
          }))
        };
      }
      return {};
    }
  },
  methods: {
    ...mapActions('product', [
      'load', //
    ]),
    async onCheckChange(variation) {
      if (variation && variation.value && variation.value.hashKey) {
        await this.load({
          id: variation.value.hashKey
        });
        this.$emit('input');
      }
    },
  },
};
</script>

<style lang="scss">
@import '~@article/pixel/dist/style/variables';

.variation {
  @media (min-width: $tablet-breakpoint - 1) {
    margin: 25px 0px;
  }
}
</style>
